import React, {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {Button, ChevronRightIcon} from '@taopix/taopix-design-system';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {PageListSelector} from '../../Selectors';
import {useTaopix} from '../Context/TaopixContext';

const NextPageButton = () => {
  const app = useTaopix();
  const ui = useUiState();

  const {t} = useTranslation();

  const pageNumberList = useSelector(PageListSelector);

  const nextPage = useCallback(() => {
    const nextPageNumber = pageNumberList[pageNumberList.indexOf(ui.state.pageNumber) + 1];
    if (undefined === nextPageNumber) {
      return;
    }
    /*
    NOTE: Do not use behaviour 'smooth' on setPage because it triggers browser bugs that prevents
    two project viewers scrolling at the same time (i.e. primary and thumbnails),
    and/or scrolls to the wrong location
    */
    app.core.get('abilities').setPage(nextPageNumber).then();
  }, [ui.state.pageNumber]);

  const disabled = useMemo(() => {
    return pageNumberList.indexOf(ui.state.pageNumber) === pageNumberList.length - 1;
  }, [ui.state.pageNumber]);

  return (
    <Button
      label={t('*:str_ButtonNextPage')}
      hideLabel
      id="paginator-right"
      endIcon={<ChevronRightIcon />}
      buttonStyle={'tertiary'}
      size={'small'}
      onClick={nextPage}
      disabled={disabled}
      className={'absolute right-0 mr-lg'}
    />
  );
};

export default NextPageButton;
